import { render, staticRenderFns } from "./MatchOptionsHeader.vue?vue&type=template&id=34e6c71e&scoped=true&"
import script from "./MatchOptionsHeader.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e6c71e",
  null
  
)

export default component.exports